import {
  CavernsSubmodeKeyType,
  GameModeKey,
  HeroHandleType,
} from 'dt-common/generated/types/enums';
import { InitNewCavernsMapResult } from 'dt-common/generated/graphql-types';
import type { HeroBuild, LoadoutUnit } from 'dt-common/generated/zod';
import { CavernsDispatcher } from '~/flux/dispatchers';
import { GameStateStore, HeroBuildStore, PlayerStore, UIStore } from '~/flux/stores';

const CavernsActions = {
  addHeroToCavernsTeamSlot: function (heroHandle, slotIndex) {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.ADD_HERO_TO_CAVERNS_TEAM_SLOT,
      heroHandle,
      slotIndex,
    });
  },

  claimPassiveYields: function () {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.CLAIM_PASSIVE_YIELDS,
      game_submode: UIStore.getAll().current_game_submode,
    });
  },

  discardLootItem: function (item_id) {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.DISCARD_LOOT_ITEM,
      item_id,
    });
  },

  doorSpriteClick: function (direction) {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.DOOR_SPRITE_CLICK,
      direction,
      game_submode: UIStore.getAll().current_game_submode,
    });
  },

  initNewCavernsMap: function (startingLevel: number) {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.INIT_NEW_CAVERNS_MAP,
      startingLevel,
      game_submode: UIStore.getAll().current_game_submode,
    });
  },

  lootTile: function (tileId) {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.LOOT_TILE,
      tileId,
    });
  },

  returnToSurface: () => {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.RETURN_TO_SURFACE,
    });
  },

  setPortalLevelToCurrentDepth: () => {
    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.SET_PORTAL_LEVEL_TO_CURRENT_DEPTH,
      game_submode: UIStore.getAll().current_game_submode,
    });
  },

  startCavernsBattleEngine: ({
    new_caverns_data,
  }: {
    new_caverns_data: InitNewCavernsMapResult & { game_submode: CavernsSubmodeKeyType };
  }) => {
    const active_caverns_loadout: LoadoutUnit[] = GameStateStore.getAll().gameState!.loadouts[
      GameModeKey.GAME_MODE_caverns
    ][new_caverns_data.game_submode].filter(({ engagement }: LoadoutUnit) => !!engagement);

    const builds = active_caverns_loadout.reduce(
      (result, loadout_member: LoadoutUnit) => {
        const unit_handle = loadout_member.handle;
        const unit_loadout = active_caverns_loadout.find(({ handle }) => handle === unit_handle);
        result[unit_handle] = HeroBuildStore.getAll().hero_builds[unit_handle].find(
          ({ _id, hero_build_id }) => [_id, hero_build_id].includes(unit_loadout!.hero_build_id)
        );
        return result;
      },
      {} as Record<HeroHandleType, HeroBuild>
    );

    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.START_CAVERNS_BATTLE_ENGINE,
      new_caverns_data,
      game_submode: new_caverns_data.game_submode,
      white_team: {
        player: PlayerStore.getAll().loggedInPlayer,
        loadout: active_caverns_loadout,
        roster: GameStateStore.getAll().gameState!.hero_roster,
        builds,
      },
    });
  },
};
export default CavernsActions;
